import { useEffect, useState } from "react";
import {
  setTournamentUserCount,
  updateUserCount,
} from "../../../../../api/tournament-timer";
import { useControllerContext } from "../../../hooks/controller-context";
import { getTournamentUser } from "../../../../../api/tournament-participant";
import { pubState } from "../../../../../recoil/pub.atom";
import { isTournamentAccess } from "../../../../../utils/owner";
import { useRecoilValue } from "recoil";

export const useTournamentUser = () => {
  const { data, getData } = useControllerContext();
  const [userCountInput, setUserCountInput] = useState(0);
  const pub = useRecoilValue(pubState);

  useEffect(() => {
    if (data?.userCount !== undefined) setUserCountInput(data?.userCount);
  }, [data?.userCount]);

  const handleUpdateUserCount = async (value: number) => {
    if (!data) return;
    if (!isTournamentAccess(data.id, pub?.tournamentIds)) {
      alert(`토너먼트 ID ${data.id}에 대한 권한이 없습니다. `);
      return;
    }
    if (value < 0) {
      if (data.userCount === 0) {
        alert("더 이상 줄일 수 없습니다.");
        return;
      }
    } else {
      if (data.userCount >= data.entryUserCount) {
        alert("엔트리 수치를 초과할 수 없습니다.");
        return;
      }
      const userList = await getTournamentUser(+data.id);
      if (data.userCount >= userList.totalSitIn) {
        alert("싯인 유저수를 초과할 수 없습니다.");
        return;
      }
    }

    try {
      await updateUserCount(data?.id, value);
      getData();
    } catch (e: any) {
      if (e.status === 403) {
        alert(e.response.data.message);
        return;
      }
      alert(e.message);
    }
  };

  const handleInputUserCount = async () => {
    if (!data?.timerDto) return;
    if (!isTournamentAccess(data.id, pub?.tournamentIds)) {
      alert(`토너먼트 ID ${data.id}에 대한 권한이 없습니다. `);
      return;
    }
    if (userCountInput < 0) {
      alert("0이하로 설정할 수 없습니다. ");
      return;
    }

    if (
      data.entryUserCount + data.adOnUserCount + data.reBuyInUserCount <
      userCountInput
    ) {
      alert("전체 엔트리보다 현재 유저가 클 수 없습니다.");
      return;
    }

    try {
      await setTournamentUserCount(data.id, userCountInput);
    } catch (e: any) {
      console.error(e);
      setUserCountInput(data.userCount);
      if (e.status === 403) {
        alert(e.response.data.message);
        return;
      }
      alert(e.message);
    }
  };

  return {
    userCountInput,
    setUserCountInput,
    handleUpdateUserCount,
    handleInputUserCount,
  };
};
